<template>
	<div class="inbox-head">
		<user-block></user-block>
		<vue-perfect-scrollbar class="inbox-sidebar-scroll">
			<div class="inbox-inner pa-2">
				<div class="mailbox-items-warp">
					<v-list>
						<template v-for="(item, index) in items">
							<v-list-tile :key="index" :to="{ name: item.routeName}" replace>
								<v-list-tile-action>
									<v-icon size="medium">{{ item.icon }}</v-icon>
								</v-list-tile-action>
								<v-list-tile-content>
									<span>{{ item.name }}</span>
								</v-list-tile-content>
							</v-list-tile>
						</template>
					</v-list>
				</div>
			</div>
		</vue-perfect-scrollbar>
	</div>
</template>

<script>
	import UserBlock from "./UserBlock";
	export default {
		data: () => ({
			items: []
		}),
		computed: {
            menuPermissions () {
                return {
                    empresa: this.$store.getters.getPermission('empresa.show'),
                    usuarios: this.$store.getters.getPermission('user.show'),
                    sedes: this.$store.getters.getPermission('sedes.show'),
                    facturas: this.$store.getters.getPermission('facturas.show'),
                    precios: this.$store.getters.getPermission('precios.show')
                }
            }
		},
        mounted () {
			console.log('eso vaaaa')
            this.menuPermissions.empresa && this.items.push({icon: 'zmdi zmdi-balance', name: 'Empresa', routeName: 'InformacionEmpresa'})
            this.menuPermissions.sedes && this.items.push({icon: 'fas fa-clinic-medical', name: 'Sedes', routeName: 'Sedes'})
            this.menuPermissions.usuarios && this.items.push({icon: 'zmdi zmdi-accounts', name: 'Usuarios', routeName: 'Usuarios'})
            this.menuPermissions.facturas && this.items.push({icon: 'fas fa-file-invoice-dollar', name: 'Facturas', routeName: 'Facturas'})
            this.menuPermissions.precios && this.items.push({icon: 'fas fa-money-check-alt', name: 'Precios', routeName: 'Precios'})
        },
		methods: {
		},
		components: {
			UserBlock
		}
	};
</script>
